"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementUnits = void 0;
var MeasurementUnits;
(function (MeasurementUnits) {
    MeasurementUnits["MILLILITRES"] = "ml";
    MeasurementUnits["LITRES"] = "l";
    MeasurementUnits["KILOGRAMS"] = "kg";
    MeasurementUnits["GRAMS"] = "grams";
    MeasurementUnits["DEKAGRAMS"] = "dgr";
    MeasurementUnits["INCHES"] = "in";
    MeasurementUnits["FEET"] = "ft";
    MeasurementUnits["TONES"] = "st";
    MeasurementUnits["POUNDS"] = "lb";
    MeasurementUnits["PINTS"] = "pt";
    MeasurementUnits["QUANTITY"] = "qty";
    MeasurementUnits["METRES"] = "m";
    MeasurementUnits["MILLIMETRES"] = "mm";
    MeasurementUnits["CENTIMETERS"] = "cm";
    MeasurementUnits["GALLONS"] = "gal";
})(MeasurementUnits = exports.MeasurementUnits || (exports.MeasurementUnits = {}));
